import React, { Fragment, useEffect, useState } from 'react'
import useAppContext from '../../../../../context/useAppContext'
import useRequest from '../../../../../hooks/useRequest'
import { StepContextProvider, useWizardContext } from "../../../../StepContext";  

const toPrefixFromIban = (arg) => {
  try {
    const replace = arg
      .replace(/[^\dA-Z]/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
    return replace;
  } catch (e) {
    return "";
  }
};
const EpisodeFour = (props) => {
    const wizardContext = useWizardContext();
    const [iban, setIban] = useState("TR");
    const [fullname, setFullname] = useState("")
    const { startFetch, response, loading, startFetchFormData } = useRequest()
    const [danger, setDanger] = useState({ valid: false, message: "" })
    const { innerTexts, tc } = useAppContext();
    const [virmanCheck, setVirmanCheck] = useState(false)
    const [urlClickedCount, setUrlClickedCount] = useState(0)
    const [ibanCheckInProgress, setIbanCheckInProgress] = useState(false)
    const [ibanValidationActive, setIbanValidationActive] = useState(null)

    useEffect(() => {
        if (response) {
            if (response.errNo === 0) {
                if (response.bilgiler) {
                    var data = response.bilgiler
                    if (data.iban) {
                        setIban(toPrefixFromIban(data.iban) || "")
                    }
                    if (data.ad) {
                      setFullname("" + data.ad + " " + data.soyad)
                    }
                }
            }
        }
    }, [response])

    useEffect(() => {

        startFetch("islem=yatirimci_bilgileri_getir&step=3", "GET")

    }, [])
    useEffect(() => {

      startFetch("islem=kimlik_bilgileri_getir&step=1", "GET")
    }, [])
    const formatIbanForRequest = (value) => {
      const stripped = (value || "").replace(/\s/g, "");
      const withoutPrefix = stripped.replace(/^TR/, "");
      return stripped && stripped !== "TR" ? "TR" + withoutPrefix : "";
    };

    const submitIbanForm = (payload) => {
      startFetchFormData(
        "islem=banka_hesap_bilgileri",
        payload,
        {
          queryParams: {},
        },
        (data) => {
          if (data.errNo === -16) {
            setDanger({
              message:
                "Girmis oldugunuz Banka Iban bilgisini kontrol eder misiniz",
              valid: true,
            });
          }

          if (data.errNo === 0) {
            wizardContext.ileri();
          }
        },
      );
    };

    const checkIbanValidationActive = (callback) => {
      if (ibanValidationActive !== null) {
        return callback(ibanValidationActive);
      }

      setIbanCheckInProgress(true);
      startFetchFormData(
        "islem=iban_dogrulama_aktif_mi",
        {},
        { useSetter: false, method: "GET" },
        (data) => {
          if (data?.errNo === -4) {
            window.location.replace("/");
            setIbanCheckInProgress(false);
            return callback(false);
          }
          const servisAktifMi = data?.servisAktifMi;
          const isActive = servisAktifMi === true || servisAktifMi === "True" || servisAktifMi === "true";
          const isInactive = servisAktifMi === false || servisAktifMi === "False" || servisAktifMi === "false";
          setIbanValidationActive(isActive);

          if (isActive) {
            setIbanCheckInProgress(false);
            return callback(true);
          }

          if (isInactive) {
            setIbanCheckInProgress(false);
            return callback(false);
          }

          if (data?.errNo !== 0) {
            setDanger({ valid: true, message: data?.errDesc || "IBAN dogrulama servisine ulasilamadi. Lutfen daha sonra tekrar deneyin." });
            setIbanCheckInProgress(false);
            return callback(null);
          }

          setIbanCheckInProgress(false);
          callback(false);
        }
      );
    };

    const validateIbanIfNeeded = (ibanValue, callback) => {
      if (ibanValidationActive === false) {
        return callback(true);
      }

      checkIbanValidationActive((isActive) => {
        if (isActive === null) {
          return;
        }
        if (!isActive) {
          return callback(true);
        }

        startFetchFormData(
          "islem=iban_dogrula",
          { 
            iban: ibanValue, 
            kimlik_no: tc,

            // mock icin kullanabilinir
            // 0 : Başarılı
            // 2 : Parametre Hatası
            // 3 : Doğrulama Hakkı Yok
            // 4 : Kimlik Bilgisi Getirilemedi
            // 5 : KKB Servisi Hata Döndü
            // 6 : Servis Bağlantı Hatası

            // testHataKodu: 0
          },
          { useSetter: false },
          (data) => {
            if (data?.errNo !== 0 || data?.dogrulamaSonucu !== true) {
              setDanger({
                message: data?.errDesc || innerTexts.error_messages_wrong_iban,
                valid: true,
              });
              return callback(false);
            }

            setDanger({ valid: false, message: "" });
            return callback(true);
          }
        );
      });
    };

    const saveForm = () => {
      
      var errorElement = window.jQuery("html");
      var scrollPosition = errorElement.offset().top - 25;
      window.jQuery('html, body').animate({ scrollTop: scrollPosition }, 500);
      setDanger({ valid: false, message: "" });

        if (innerTexts.id === 'DINAMIK' && !virmanCheck) {
          setDanger({ message: 'Genel Virman Transfer Talimatini okuyup onaylayiniz!', valid: true })
          return
        }

        const hasIbanValue = iban && iban.length === 32;
        const ibanToSend = hasIbanValue ? formatIbanForRequest(iban) : "";

        if (innerTexts.companyIbanRequired) {
          if (!hasIbanValue) {
            setDanger({ message: innerTexts.error_messages_wrong_iban, valid: true })
            return
          }

          return validateIbanIfNeeded(ibanToSend, (ibanIsValid) => {
            if (!ibanIsValid) {
              return;
            }

            submitIbanForm({
              iban: ibanToSend,
            });
          });
        }

        if (hasIbanValue) {
          return validateIbanIfNeeded(ibanToSend, (ibanIsValid) => {
            if (!ibanIsValid) {
              return;
            }

            submitIbanForm({
              iban: ibanToSend,
            });
          });
        }

        if (iban === 'TR') {
          submitIbanForm({});
          return;
      }

      setDanger({ valid: true, message: innerTexts.error_messages_wrong_iban })
    }

    const isBusy = loading || ibanCheckInProgress;

    return (
      <Fragment>
        <div style={{ textAlign: "center" }}>
          <h2> </h2>
          <div style={{ textAlign: "left" }} className="row">
            <div className="col-md-12">
              <div
                style={{ cursor: "pointer", width: "100%" }}
                className="card"
              >
                <div style={{ cursor: "pointer" }} className="card-body">
                  <div key={0}
                    style={{ display: "block", zIndex: 2 }}
                    className="input-group  input-group-lg lg-12"
                  >
                    <div className="input-group-prepend">
                      <label className="control-label">
                        {" "}
                        {innerTexts.label_account_name}
                      </label>
                    </div>
                    <input
                      disabled
                      type="text"
                      value={fullname}
                      onChange={(e) => {
                        if (e.target.value.length <= 32)
                          setIban(toPrefixFromIban(e.target.value));
                      }}
                      required="required"
                      className="form-control"
                    />
                  </div>
                  <div
                    style={{ display: "block", zIndex: 2 }}
                    className="input-group  input-group-lg lg-12"
                  >
                    <div className="input-group-prepend">
                      {innerTexts.companyIbanRequired ? (
                        <label className="control-label">
                          {innerTexts.label_iban_required}
                        </label>
                      ) : (
                          <label key={1} className="control-label">
                          {innerTexts.label_iban_not_required}
                        </label>
                      )}
                    </div>
                    <input
                      value={iban}
                      onChange={(e) => {
                        if (e.target.value.length >= 2 && e.target.value.length <= 32)
                          setIban( toPrefixFromIban('TR' + e.target.value.replace('TR', '')));
                      }}
                      onPaste={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        const clipboardData = e.clipboardData || window.clipboardData;
                        const pastedData = clipboardData.getData("Text");
                        if (pastedData.length >= 2 && pastedData.length <= 32)
                            setIban( toPrefixFromIban('TR' + pastedData.replace('TR', '')));
                      }
                      }
                      placeholder="TR"
                      type="text"
                      required="required"
                      className="form-control"
                    />
                  </div>
                  {
                    innerTexts.id === 'DINAMIK' && 
                    <div
                    style={{ marginTop: "15px" }}
                    >
                        <input
                                onClick={(e) => {
                                    if (innerTexts.id === "DINAMIK") {
                                            window.open(innerTexts.label_privacy_url_2, "_blank");
                                            setUrlClickedCount(1);
                                            setVirmanCheck(true);
                                            setDanger({ valid: false, message: "" })
                                            if (urlClickedCount === 1) {
                                                setDanger({ valid: false, message: "" })
                                                e.preventDefault();
                                        }
                                    }
                                }}
                                defaultChecked={virmanCheck}
                                checked={virmanCheck}
                                style={{ marginRight: 5}}
                                className="form-check-input"
                                type="checkbox"
                                id="agreementCheckbox"
                            />
                            <label className="form-check-label" 
                            style={{
                                color: "black",
                                fontSize: 14,
                                fontWeight: "400",
                                marginLeft: 10
                            }} 
                            // htmlFor={item.value.trim()}
                            > 
                            <a href='/static/pdf/genelVirman.pdf' onClick={()=> {setUrlClickedCount(1); setVirmanCheck(true); setDanger({ valid: false, message: "" })} } target='_blank'>Genel Virman Transfer Talimatı bilgilendirme metnini</a> okuduğumu onaylıyorum.
                            </label>

                    </div>
                  }
                  <div className="col-md-12">
                    <div
                      style={{ marginTop: 10 }}
                      className="alert alert-info"
                      role="alert"
                    >
                      {innerTexts.label_iban_warning}
                    </div>
                  </div>
                  <div className="col-md-12">
                    {danger.valid ? (
                      <div
                        style={{ marginTop: 10 }}
                        className="alert alert-danger"
                        role="alert"
                      >
                        {danger.message}
                      </div>
                    ) : (
                      void 0
                    )}
                  </div>
                  <div style={{ marginTop: 20 }} className="col-md-6">
                    <button
                      onClick={() => {
                        wizardContext.geri();
                      }}
                      className="btn  btn-secondr btn-lg btn-block"
                      disabled={isBusy}
                      style={{ filter: isBusy ? "brightness(120%)" : "", cursor: isBusy ? "no-drop" : "pointer" }}
                    >
                      {innerTexts.btn_text_back}
                    </button>
                  </div>

                  <div style={{ marginTop: 20 }} className="col-md-6">
                    <button
                      onClick={saveForm}
                      className="btn  btn-primary btn-lg btn-block"
                      disabled={isBusy}
                      style={{ filter: isBusy ? "brightness(120%)" : "", cursor: isBusy ? "no-drop" : "pointer" }}
                    >
                      {isBusy ? "Yükleniyor..." : innerTexts.btn_text_forward}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
}
export default StepContextProvider(EpisodeFour, {
  viewHider(props) {
    if (!props.innerTexts.ibanStep) {
      return true;
    }
  }
});
